import React, { useRef } from "react";

export default function RetrieveTradPopup({ onClose }) {
  const nameRef = useRef();

  // React.useEffect(() => {
  //   document.body.style.overflow = 'hidden';
    
  //   return () => {
  //     document.body.style.overflow = 'unset';   // Re-enable scroll when closed
  //   };
  // }, []);

  const guestList = [
    "LINUS ULAA",
    "ROSEMARY ULAA",
    "DAVID ULAA",
    "DANIEL ULAA",
    "NAOMI",
    "CHIDOZIE",
    "LALA NEDU",
    "ROSY CHINEDU",
    "CHRISTIAN ULAA",
    "ROSE ULAA",
    "JOSHUA ULAA",
    "MR & MRS IKECHUKWU",
    "WILSON OKERE",
    "RUTH ULAA",
    "IFEANYI CHUKWUMA",
    "NICK OBIYO",
    "CHIDINMA OBIYO",
    "FRANCA AFE",
    "ALERO",
    "NONYE",
    "OFILI",
    "NWANCHUKWU",
    "KELECHI OBIYO",
    "VICTORIA OBIYO",
    "AKUDO OBIYO",
    "GIFT OLANIYAN",
    "TONY FRIDAY",
    "TONY OBIHAI",
    "CHRIS OBIHAI",
    "OYIBO NWANJI",
    "JUDE OGWU",
    "DANIEL OKOLIE",
    "MOSES UGBA",
    "CHIDE MEDEI",
    "GARVIN NWANJI",
    "NWIKE OKAFOR",
    "ALBERT AGOH",
    "CHIKE AFUWAH",
    "AUSTIN NWOKOLO",
    "JOSEPH OKWE",
    "DUNKWU LUGARD",
    "OFUNNE OKAFOR",
    "JOHN OGWU",
    "CHIEF JUDE OJEDE",
    "JUDE IKEJI",
    "AMBROSE ONWUEGBUZIE",
    "HENRY EGBUNE",
    "CHARLES UMEADI",
    "IBEH BANWUZIA",
    "PETER EMORDI",
    "MIKE OKONKWO",
    "EMMANUEL OKOCHA",
    "OGWU GODWIN",
    "EBUBE KIKI",
    "ONYENA CHARITY",
    "KENNEDY IBEKWE",
    "CHIEF CHUCKS NZEI",
    "OLAWALE AJIBOYE",
    "TONY NWANUA",
    "KOBICO TONY",
    "FELICIA UWAECHIE",
    "AZU NWANUA",
    "SIMEON NWANUA",
    "OLUCHUKWU NWAOKOLO",
    "BUCHI ADETUBO",
    "HERRIETA UWADO",
    "CHIEF FRANCIS ONWUEGBUZIE",
    "OBIORA IFEANYI",
    "OBA SIMON",
    "OBRIEN ONWUEGBUZIE",
    "DASYLVA",
    "TONNA NWANUA",
    "DOLAPO MAJEKODUNMI",
    "NWANUA KINGSLEY",
    "OSCAR ONWUEGBUZIE",
    "A C JIDEOWON",
    "JOHN OBI",
    "POLYCARP OKOLIE",
    "EMENE OKOLIE",
    // "DARALOYE DORCAS",
    // "AMARACHI ASUGHA",
    // "OLADELE ELIZABETH",
    // "FEMI BABATUNDE",
    // "ODOFIN BABATUNDE",
    // "FRANK AMEH",
    // "PRECIOUS EBENEZER",
    // "NONSO UKAIGWE",
    // "FORTUNE ANI",
    // "ESTHER OSAYUWA",
    // "OHIS IGELEKE",
    // "OMOLOLU ONI",
    // "MR & MRS AKHILOME",
    // "MR & MRS JEGEDE",
    // "DANIELLE RURO",
    // "AKAIGHE ELOHOR",
    // "SOPHIA ASEKHAUNO",
    // "DANIELA ARINZE",
    // "PEARL ARINZE",
    // "OPEYEMI HUSSAIN",
    // "TITILOPE ADEDEJI",
    // "VICTOR AKINSEIDE",
    // "ROTIMI ALLI",
    // "IRETI OGUNBOWALE",
    // "OLAJUMOKE TIJANI",
    // "OLUWABUKOLA ADEYEMI",
    // "TEMILOLU OLUWABUSOLA",
    // "WEYINMI BIBI",
    // "ARIKPO EBRI",
    // "EMMANUEL ADESHINA",
    // "OLADUNNI SHOSIMI",
    // "CHETACHI ELELEME",
    // "ISLAMIYAT ISIBOR",
    // "CHIMDINDU IBEH",
    // "ADAOBI EZEOKAFOR",
    // "JOHN EGBO",
    // "ARINZE UMEHOBI",
    // "OFEIMUN DESMOND",
    // "RITA IFEANYICHUKWU",
    // "AYOBAMI TIJANI",
    // "RONKE ABOSEDE",
    // "OLAYIMIKA AKINYEMI",
    // "MOYIN AROWOLO",
    // "OGUNSOLA YEMI",
    // "OGUNSOLA IFE",
    // "OLAMIDE DAHUNSI",
    // "GIDEON DURUNWA",
    // "PROSPER EBENEZER",
    // "JOYCELYN EFFIONG",
    // "EVELYN ARUWAYO",
    // "GODWIN ARUWAYO",
    // "GIFT ENNY",
    // "JERMAINE DANIEL",
    // "ALUYA FAVOUR",
    // "DAVID DURU",
    // "CHIKWELUGO HILARY",
    // "MMERE EZUMA-UKWU",
    // "ALUYA FAVOUR",
    // "MICHAEL OKEREKE",
    // "TITILOPE OYEGUNWA",
    // "OGUNLEYE DEMOLA",
    // "DR AUSTIN",
    // "DORRIS NAPOLEON",
    "FELIX NWANUA",
    "IFEOMA NWANUA",
    "CONFIDENCE NWANUA",
    "GLORY NWANUA",
    "DAVID NWANUA",
    "JOSEPH NWANUA",
    "AMAKA CHUKWURAH",
    // "MR & MRS GBANIRO",
    // "BENJAMIN WHYSS",
    // "SYLVIA WHYSS",
    // "TONNA NWANUA",
    // "AMAKA CHUKWURAH",
    // "AZU NWANUA",
    // "IFEOLUWA ASAMO",
    // "FEMI ABIOYE",
    // "KAFAYAT SALAWU",
    // "ADEJUMOKE AKINNUWESI",
    // "OLAMIDE AKANJI",
    // "TEMITOPE AWELEWA",
    // "MARIA AUGUSTINE",
    // "AYODEJI OMONIYI",
    // "ISLAMIYAT ADEAGBO",
    // "RACHAEL OVIENLOBA"
  ];

  const handleGenerateInvite = () => {
    const name = nameRef.current.value.trim();
    if (!name) {
      alert("Please enter your full name");
      return;
    }

    // convert to lowercase for checking
    const formattedName = name.toUpperCase();

    // check if name exists in guest list
    const guestExists = guestList.includes(formattedName);

    if (!guestExists) {
      alert("Invite not Found");
      return;
    }

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.src = "/invite-template2.png"; // put invite image in public/
    img.crossOrigin = "anonymous";

    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;

      // Draw background invite
      ctx.drawImage(img, 0, 0);

      // Add guest name in calligraphy
      ctx.font = "50px 'Saira Stencil', cursive";
      ctx.fillStyle = "#0c4689"; // wedding theme wine red
      ctx.textAlign = "center";
      ctx.fillText(name, canvas.width / 2, canvas.height - 250);

      // Download personalized invite
      const link = document.createElement("a");
      link.download = `${name}-invite.jpg`;
      link.href = canvas.toDataURL("image/jpeg");
      link.click();
    };

    onClose(); // close popup after download
  };

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <h2 className="text-2xl mb-4 font-semibold">Retrieve Guest Invite</h2>
        <input
          type="text"
          ref={nameRef}
          placeholder="Enter your full name"
          className="border border-gray-300 rounded px-3 py-2 w-full mb-4"
        />
        <button
          onClick={handleGenerateInvite}
          className="bg-pink-600 text-white px-6 py-2 rounded-lg hover:bg-pink-700 transition"
        >
          Retrieve Invite
        </button>
        <button
          onClick={onClose}
          className="ml-3 text-gray-600 underline"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
